import React from 'react';
interface BowMarkProps {
  className?: string;
}

/** Small stitched bow used beside the wordmark. Decorative. */
export function BowMark({
  className = 'h-6 w-9'
}: BowMarkProps) {
  return <svg viewBox="0 0 48 32" fill="none" className={className} aria-hidden data-id="element-31" data-mp="12jnpd8du01q6">
      <path d="M24 15C17 5 5 5 5 14.5S17 25 24 15Z" fill="#EF6488" fillOpacity="0.18" stroke="#EF6488" strokeWidth="2" strokeLinejoin="round" data-id="element-32" data-mp="17ja1tflu5dxx" />
      <path d="M24 15C31 5 43 5 43 14.5S31 25 24 15Z" fill="#EF6488" fillOpacity="0.18" stroke="#EF6488" strokeWidth="2" strokeLinejoin="round" data-id="element-33" data-mp="9tox744cboha" />
      <path d="M22 17l-6 12M26 17l6 12" stroke="#EF6488" strokeWidth="2" strokeLinecap="round" data-id="element-34" data-mp="okfma4ejs9gp" />
      <path d="M10 14.5c3-3 7-3 10 0M38 14.5c-3-3-7-3-10 0" stroke="#8B967D" strokeWidth="1.2" strokeDasharray="2 2" strokeLinecap="round" data-id="element-35" data-mp="om8rrgdfcnn4" />
      <circle cx="24" cy="15" r="3.2" fill="#EF6488" data-id="element-36" data-mp="3s7ejrwcr54pl" />
    </svg>;
}